import React, { useState, useMemo } from "react";
import "../DashboardUnique.css";
import { exportGrantVillagesToExcel, exportVillagesToExcel, exportVillagesToPDF, toIndianCurrency, toIndianCurrencyVillageCard } from "../../../MethodMaster/JSXComponentMothod";
import { parse } from "date-fns";

const ShimmerCard = () => (
  <div className="govdash-villageCard-final">
    <div className="village-shimmer" style={{ height: "1rem", marginBottom: "0.6rem" }}></div>
    <div className="village-shimmer" style={{ height: "1.7rem" }}></div>
  </div>
);

const NoDataCard = () => (
  <div className="govdash-villageCard-final govdash-noVillageCard">
    <div className="govdash-noDataIcon">
      <i className="fas fa-village fa-2x"></i>
    </div>
    <div className="govdash-noDataTitle">No Villages Found</div>
    <div className="govdash-noDataDesc">
      {document.querySelector(".govdash-searchInput")?.value ? "Try searching with different keywords" : "No villages available under this Yojana"}
    </div>
  </div>
);

export default function GrantVillageGrid({ selYojna = null, villages = [], onSelect, isLoading = false }) {
  const [search, setSearch] = useState("");
  const themes = ["glass-0", "glass-1", "glass-2", "glass-3", "glass-4"];

  const filteredVillages = useMemo(() => {
    if (!search.trim()) return villages.filter((v) => v?.Village?.trim());
    return villages.filter((v) => v?.Village?.toLowerCase().includes(search.trim().toLowerCase()));
  }, [villages, search]);
  const handleExcel = () => exportGrantVillagesToExcel(selYojna, filteredVillages, "Grant_Yojana_Village");
  let TotalAmount = 0;
  // const handlePDF = () => exportVillagesToPDF(selYojna, filteredVillages, "Villages_Under_Yojna")
  return (
    <>
      <div className="d-flex justify-content-between">
        <h3 className={"govdash-sectionTitle"}>
          Villages under this grant yojana
          {/* &nbsp;&nbsp;&nbsp; */}
          {/* <div className="govdash-totalCountBadge" >

            <span className="govdash-totalNumber">{villages.length}</span>
          </div> */}
        </h3>
        {/* Search Bar */}
        <div className="d-flex gap-2">
          <div className="d-flex gap-3 align-items-center flex-wrap">
            <div className="govdash-searchWrapper">
              <i className="fas fa-search "></i>
              <input type="text" placeholder="Search Village Name..." value={search} onChange={(e) => setSearch(e.target.value)} className="govdash-searchInput" />
              {search && (
                <button onClick={() => setSearch("")} className="govdash-clearSearch">
                  <i className="fas fa-times"></i>
                </button>
              )}
            </div>
          </div>
          <div>
            <button onClick={handleExcel} className="govdash-excelBtn mt-4">
              <i className="fas fa-file-excel"></i> Export Excel
            </button>
          </div>
          {/* <div>
          <button onClick={handlePDF} className="govdash-pdfBtn mt-4">
            <i className="fas fa-file-pdf"></i> Download PDF
          </button>
          </div> */}
        </div>
      </div>

      <div className="govdash-villageGrid-final">
        {isLoading ? (
          Array(24)
            .fill()
            .map((_, i) => <ShimmerCard key={i} />)
        ) : filteredVillages.length > 0 ? (
          filteredVillages.map((v, idx) => {
            const theme = themes[idx % 5];
            const hasAmount = v?.TotalAmount > 0;

            return (
              <div key={v.id} className={`govdash-villageCard-final yojna-${theme}`} onClick={() => onSelect(v)}>
                <div className="village-header-final">
                  <div className="village-name-final">{v.Village}</div>
                  {/* {v?.VillageVoterCount > 0 && (
                    <div className="voter-badge">
                      {v.VillageVoterCount.toLocaleString()} Voters
                    </div>
                  )} */}
                </div>

                <div className="beneficial-row-final">
                  <span className="label">Grant Details</span>
                  <span className="value">{v.GrantDetailCount.toLocaleString() || "0"}</span>
                </div>

                <div className="amount-expression">
                  {v.IsYojanaAmount ? (
                    <span className="formula">
                      ₹{parseFloat(v?.YojanaAmount)}
                      <i className="fa fa-times mx-1"></i>
                      {parseFloat(v?.TotalAmount)}
                    </span>
                  ) : null}
                </div>

                {/* <div className="amount-expression">
                  {v.IsYojanaAmount ? (
                    <span className="formula">
                      {toIndianCurrency(v?.YojanaAmount)}
                      <i className="fa fa-times mx-1"></i>
                      {toIndianCurrency(v?.TotalAmount)}
                    </span>
                  ) : null}
                </div> */}

                {/* {hasAmount && (
                  <div className="amount-row-final">
                    {v.IsYojanaAmount ? parseFloat(v.YojanaAmount) * parseFloat(v.TotalAmount) : `₹${v.TotalAmount?.toLocaleString("en-IN")}`}
                  </div>
                )} */}
                {hasAmount && (
                  <div className="amount-row-final">
                    {v.IsYojanaAmount ? toIndianCurrencyVillageCard(parseFloat(v?.YojanaAmount) * parseFloat(v.TotalAmount)) : toIndianCurrencyVillageCard(v?.TotalAmount)}
                    {/* ₹{v.TotalAmount.toLocaleString('en-IN')} */}
                  </div>
                )}
              </div>
            );
          })
        ) : (
          <NoDataCard />
        )}
      </div>
    </>
  );
}
